var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"twitter_2_2","data-name":"twitter (2)","d":"M7.694,16.034c9.134,0,14.129-7.64,14.129-14.264q0-.325-.014-.648a10.16,10.16,0,0,0,2.477-2.6,9.835,9.835,0,0,1-2.852.789,5.024,5.024,0,0,0,2.184-2.773A9.9,9.9,0,0,1,20.465-2.24,4.939,4.939,0,0,0,16.84-3.824a4.99,4.99,0,0,0-4.966,5.013A5.054,5.054,0,0,0,12,2.331,14.056,14.056,0,0,1,1.766-2.906a5.038,5.038,0,0,0-.672,2.52A5.022,5.022,0,0,0,3.3,3.786a4.892,4.892,0,0,1-2.249-.627c0,.021,0,.042,0,.064A5,5,0,0,0,5.038,8.138a4.94,4.94,0,0,1-1.31.176,4.89,4.89,0,0,1-.933-.09,4.978,4.978,0,0,0,4.639,3.482,9.9,9.9,0,0,1-6.168,2.146,10.013,10.013,0,0,1-1.185-.069,13.961,13.961,0,0,0,7.612,2.252","transform":"translate(-0.082 3.824)"}));
}

Twitter.defaultProps = {"id":"twitter_2_","data-name":"twitter (2)","width":"24.205","height":"19.859","viewBox":"0 0 24.205 19.859"};

module.exports = Twitter;

Twitter.default = Twitter;
